module.exports = __webpack_public_path__ + "media/images/weather/20_day_g-3e9434688977d3757a0674daefab019f.png";